import {
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Expand } from "lucide-react";
import React, { ReactNode, useState } from "react";
import { DialogComponent } from "./Dialog";

interface IExpandableDialogProps {
  children: ReactNode;
  title: string;
  translate: (text: string, options?: any) => string;
}

export const ExpandableDialog: React.FC<IExpandableDialogProps> = (props) => {
  const { children, title, translate } = props;
  const { palette } = useTheme();

  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpandDialog = () => setIsExpanded(!isExpanded);

  const enhancedChildren = React.isValidElement(children)
    ? React.cloneElement(children, {
        isExpanded,
      })
    : children;

  return (
    <>
      <Box
        sx={{
          backgroundColor:
            palette.mode === "dark"
              ? palette.grey[900]
              : palette.background.paper,
          border: `1px solid ${palette.text.borderLine}`,
          borderRadius: 2,

          my: 1,
        }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: `1px solid ${palette.text.borderLine}`,
            py: 2,
            px: 1,
          }}
          spacing={1}
        >
          <Typography variant="subtitle1">{title}</Typography>
          {/* <Tooltip title={translate("expand")}>
            <IconButton
              size="small"
              onClick={handleExpandDialog}
              sx={{
                border: `1px solid ${palette.primary.main}`,
                backgroundColor: "#fff",
                p: 0.5,
                height: 32,
                width: 32,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Expand size={16} />
            </IconButton>
          </Tooltip> */}
        </Stack>
        {enhancedChildren}
      </Box>
      <DialogComponent
        dialogTitle={title}
        isShowModal={isExpanded}
        showModalMethod={handleExpandDialog}
        dialogContent={enhancedChildren}
        fullWidth
        maxWidth="md"
      />
    </>
  );
};
